export const SET_SORT = 'SET_SORT';

export const setSort = (typeSort) => {
  return {
    type: SET_SORT,
    payload: typeSort,
  };
};
